var map = {
	"./Celery.svg": "02e8",
	"./Chilli.svg": "7989",
	"./Crustacean.svg": "9053",
	"./Eggs.svg": "a553",
	"./Fish.svg": "8281",
	"./Gluten.svg": "106c",
	"./Lupin.svg": "6a13",
	"./Milk.svg": "b2ee",
	"./Molluscs.svg": "03ca",
	"./Mustard.svg": "18fc",
	"./Nuts.svg": "5099",
	"./Peanuts.svg": "9119",
	"./Sesame.svg": "3d3a",
	"./Soya.svg": "651a",
	"./Sulphur Dioxide.svg": "698a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "355b";